export type BuildingType =
    | 'house'
    | 'stoneHouse'
    | 'lumberjackCamp'
    | 'sawmill'
    | 'farm'
    | 'huntingHut'
    | 'fishingHut'
    | 'smokehouse'
    | 'weaver'
    | 'blacksmith'
    | 'goldMine'
    | 'mint'
    | 'caravanPost'
    | 'stable'
    | 'quarry'
    | 'masonry'
    | 'charcoalPit'
    | 'ironMine'
    | 'smelter'
    | 'barracks';

export type BuildingDefinition = {
    workRequired: number;
    labelKey: string;
    slots: number;
    limitByTier: { outpost: number; town: number; city: number };
};

export const BUILDING_DEFS: Record<BuildingType, BuildingDefinition> = {
    house: {
        workRequired: 900,
        labelKey: 'buildings.label.house',
        slots: 1,
        limitByTier: { outpost: 8, town: 18, city: 30 },
    },
    stoneHouse: {
        workRequired: 1400,
        labelKey: 'buildings.label.stoneHouse',
        slots: 1,
        limitByTier: { outpost: 4, town: 12, city: 24 },
    },
    lumberjackCamp: {
        workRequired: 900,
        labelKey: 'buildings.label.lumberjackCamp',
        slots: 1,
        limitByTier: { outpost: 1, town: 2, city: 4 },
    },
    sawmill: {
        workRequired: 1200,
        labelKey: 'buildings.label.sawmill',
        slots: 1,
        limitByTier: { outpost: 1, town: 2, city: 4 },
    },
    farm: {
        workRequired: 1200,
        labelKey: 'buildings.label.farm',
        slots: 1,
        limitByTier: { outpost: 1, town: 3, city: 6 },
    },
    huntingHut: {
        workRequired: 900,
        labelKey: 'buildings.label.huntingHut',
        slots: 1,
        limitByTier: { outpost: 1, town: 2, city: 4 },
    },
    fishingHut: {
        workRequired: 1200,
        labelKey: 'buildings.label.fishingHut',
        slots: 1,
        limitByTier: { outpost: 1, town: 2, city: 4 },
    },
    smokehouse: {
        workRequired: 1200,
        labelKey: 'buildings.label.smokehouse',
        slots: 1,
        limitByTier: { outpost: 1, town: 1, city: 1 },
    },
    weaver: {
        workRequired: 2400,
        labelKey: 'buildings.label.weaver',
        slots: 1,
        limitByTier: { outpost: 0, town: 1, city: 1 },
    },
    blacksmith: {
        workRequired: 3600,
        labelKey: 'buildings.label.blacksmith',
        slots: 1,
        limitByTier: { outpost: 0, town: 1, city: 1 },
    },
    goldMine: {
        workRequired: 5400,
        labelKey: 'buildings.label.goldMine',
        slots: 1,
        limitByTier: { outpost: 0, town: 1, city: 1 },
    },
    mint: {
        workRequired: 5400,
        labelKey: 'buildings.label.mint',
        slots: 1,
        limitByTier: { outpost: 0, town: 0, city: 1 },
    },
    caravanPost: {
        workRequired: 1800,
        labelKey: 'buildings.label.caravanPost',
        slots: 1,
        limitByTier: { outpost: 1, town: 1, city: 1 },
    },
    stable: {
        workRequired: 2400,
        labelKey: 'buildings.label.stable',
        slots: 1,
        limitByTier: { outpost: 0, town: 1, city: 1 },
    },
    quarry: {
        workRequired: 1500,
        labelKey: 'buildings.label.quarry',
        slots: 1,
        limitByTier: { outpost: 1, town: 2, city: 4 },
    },
    masonry: {
        workRequired: 2400,
        labelKey: 'buildings.label.masonry',
        slots: 1,
        limitByTier: { outpost: 0, town: 1, city: 1 },
    },
    charcoalPit: {
        workRequired: 1200,
        labelKey: 'buildings.label.charcoalPit',
        slots: 1,
        limitByTier: { outpost: 1, town: 2, city: 4 },
    },
    ironMine: {
        workRequired: 1800,
        labelKey: 'buildings.label.ironMine',
        slots: 1,
        limitByTier: { outpost: 1, town: 2, city: 4 },
    },
    smelter: {
        workRequired: 1800,
        labelKey: 'buildings.label.smelter',
        slots: 1,
        limitByTier: { outpost: 1, town: 2, city: 4 },
    },
    barracks: {
        workRequired: 2400,
        labelKey: 'buildings.label.barracks',
        slots: 1,
        limitByTier: { outpost: 0, town: 1, city: 2 },
    },
};
